import React, { useEffect, useState } from 'react'
import NewModal from 'components/modal/NewModal'
import { userRolesBase } from 'model/User'
import { getDoctorsForPatients } from 'user/UserApi'
import { useTranslation } from 'react-i18next'
import 'antd/dist/antd.css'
import { Label } from '@hospitalrun/components'
import classes from '../../../../style.module.scss'
import SelectWithLabelFormGroup from 'components/input/SelectWithLableFormGroup'
import { bloodChemistry, deviceOrder, Devices, edanVitals } from 'model/Devices'
import { ComponentWrapperWithAITracking } from 'analytics/AppInsights'
import { Col, Radio, Row, InputNumber, Checkbox, Alert, Select, Button, Form } from 'antd'
import MedicalTestSearch from 'patients/medical-tests/MedicalTestSearch'
import '../../../VdgPatients.scss'
import Patient, { patientStatus } from 'model/Patient'
import Device from 'model/Device'
import PatientsDiagnosisTopics from 'model/PatientsDiagnosisTopics'
import MedicalTest from 'model/MedicalTest'
import VdgMedicalTestReferralModal from './VdgMedicalTestReferralModal'
import {
  closePatientSchedulePlan,
  createPatientSchedulePlan,
  fetchPatientExaminations,
} from 'vdg-patients/vdg-patients-diagnosis-slice'
import { useDispatch, useSelector } from 'react-redux'
import ReactSelectWithLabelFormGroup from 'components/input/ReactSelectWithLabelFormGroup'
import { RootState } from 'store'
import PatientsDiagnosis from 'model/PatientsDiagnosis'
// import TextAreaWithLabelFormGroup from 'components/input/TextAreaWithLabelFormGroup'
import DatePickerWithLabelFormGroup from 'components/input/DatePickerWithLabelFormGroup'

import './VdgTestModal.scss'
import PatientDiagnosisRepository from 'vdg-patients/appointment/PatientDiagnosisRepository'
import InternalExaminationPlan, { OrderSource } from 'model/InternalExaminationPlan'
import moment from 'moment'
import TextAreaWithLabelFormGroup from 'components/input/TextAreaWithLabelFormGroup'
import PatientsDiagnosisDiscussions from 'model/PatientsDiagnosisDiscussions'
import LockerWrapper from 'patients/view/LockerWrapper'
import {
  useDeviceAvailability,
  unavailableLabel,
} from 'settings/deviceIncidents/useDeviceAvailability'
import { ExternalEmr } from 'utils/ExternalEmr'
import TextArea from 'antd/lib/input/TextArea'
import { returnExamName } from 'model/Examination'

const { externalEMR } = (window as any).config

interface OutpatientModalProps {
  show: boolean
  parent: string
  onCloseButtonClick: () => void
  patient: Patient
  topic: PatientsDiagnosisTopics
  existingPlan?: InternalExaminationPlan
  onFieldChange?: (key: string, value: string | boolean | any[]) => void
}

export enum typeTestDef {
  internal = 'internal',
  external = 'external',
}

export enum scheduleTypeDef {
  once = 'once',
  multi = 'multi',
  every = 'every',
  continuous = 'continuous',
}

export enum severityTypeDef {
  onceADay = 'onceADay',
  onceAWeek = 'onceAWeek',
  onceTwoWeeks = 'onceTwoWeeks',
}

const VdgTestModal = (props: OutpatientModalProps) => {
  const { show, onCloseButtonClick, patient, parent, topic, existingPlan } = props
  const { userSession } = useSelector((state: RootState) => state.userSession)

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { Option } = Select

  // Devices out of service at this patient's facility (open device incidents).
  const { unavailable: unavailableDevices } = useDeviceAvailability(patient?.facilityId)

  const [tests, setTests] = useState<any[]>([])
  const [testName, setTestName] = useState<Device>()
  const [testType, setTestType] = useState<typeTestDef>(typeTestDef.internal)
  const [showMedicalTestReferralModal, setShowMedicalTestReferralModal] = useState<boolean>(false)
  const [medicalTest, setMedicalTest] = useState<MedicalTest>()
  const [allDoctors, setAllDoctors] = useState<any[]>([])
  const [prescribingDoctor, setPrescribingDoctor] = useState<any>()
  const [showAlertModal, setShowAlertModal] = useState(false)
  const { diagnosis } = useSelector((state: RootState) => state.patientDiagnosis)
  const [newExistsDiagnosis, setNewExistsDiagnosis] = useState<any[]>([
    ...(existingPlan
      ? existingPlan.patientDiagnoses
      : topic.patientDiagnoses
          ?.filter((d: { active: boolean }) => d.active)
          ?.map((pd: any) => {
            return { diagnosisCode: pd.diagnosisCode, diagnosisId: pd.diagnosisId }
          })),
  ])
  const [bloodTypes, setBloodTypes] = useState<any[]>([
    ...(existingPlan?.bloodTypes ? existingPlan.bloodTypes : []),
  ])
  const [scheduleType, setScheduleType] = useState<scheduleTypeDef>()

  const [multiDateEnd, setMultiDateEnd] = useState<string>('')
  const [everyDateEnd, setEveryDateEnd] = useState<string>('')
  const [continuousDateEnd, setContinuousDateEnd] = useState<string>('')

  const [withIn, setWithIn] = useState<number | 'ASAP'>(0)
  const [timesaday, setTimesaday] = useState<number>(1)
  const [every, setEvery] = useState<number>(1)
  const [severity, setSevirity] = useState<severityTypeDef>(severityTypeDef.onceADay)
  const [noticeMessage, setNoticeMessage] = useState<string>()
  const [doctorsRequests, setDoctorsRequests] = useState<string>()

  const [comments, setComments] = useState<string>()
  const [closeExistingPlan, setCloseExistingPlan] = useState<boolean>(false)

  const severities = [
    { label: t('examinations.dailymonitoring'), value: severityTypeDef.onceADay },
    { label: t('examinations.weeklymonitoring'), value: severityTypeDef.onceAWeek },
    { label: t('examinations.oncefor2weeks'), value: severityTypeDef.onceTwoWeeks },
  ]

  useEffect(() => {
    let tmpTest: any[] = Devices
    let newTests: any[] = []
    tmpTest.map((test: any) => {
      if (test.kind === 'device') {
        if (test.types.length > 1) {
          test.types.map((type: any) => {
            newTests.push({ ...test, ...{ types: [type] } })
          })
        } else {
          newTests.push(test)
        }
      } else {
        //order
        newTests.push(test)
      }
    })
    setTests(newTests)
  }, [])

  useEffect(() => {
    if (testName?.value !== edanVitals.value && scheduleType === scheduleTypeDef.continuous) {
      setScheduleType(undefined)
    }
  }, [testName])

  useEffect(() => {
    if (testName) {
      PatientDiagnosisRepository.checkIfScheduleExists({ patientId: patient.id, testName }).then(
        res => {
          if (res.data.examPlanExists) {
            const { examPlans } = res.data
            setNoticeMessage(t('examinations.thereIsAnExistingPlanAlready'))

            examPlans?.forEach((examPlan: any) => {
              setNewExistsDiagnosis([
                ...newExistsDiagnosis,
                ...examPlan?.patientDiagnoses?.filter(
                  ({ diagnosisCode }: any) =>
                    !newExistsDiagnosis.find(f => f.diagnosisCode === diagnosisCode),
                ),
              ])
              if (testName.value === bloodChemistry.value)
                setBloodTypes(Array.from(new Set([...bloodTypes, ...examPlan?.bloodTypes])))
              if (examPlan.scheduleType === scheduleTypeDef.multi) {
                setTimesaday(examPlan.timesADay)
                setMultiDateEnd(examPlan.endPlanDate)
              } else if (examPlan.scheduleType === scheduleTypeDef.every) {
                setEvery(examPlan.everyXHours)
                setEveryDateEnd(examPlan.endPlanDate)
              } else if (examPlan.scheduleType === scheduleTypeDef.continuous) {
                setSevirity(examPlan.severity)
                setContinuousDateEnd(examPlan.endPlanDate)
              }
            })
          } else {
            setNoticeMessage(undefined)
          }
        },
      )
    }
  }, [testName, scheduleType])

  // Only the doctors who treat this patient may be named as the prescriber —
  // the server enforces the same set when the order is saved.
  useEffect(() => {
    if (!patient?.id) {
      setAllDoctors([])
      return
    }

    let cancelled = false
    getDoctorsForPatients([patient.id])
      .then(res => {
        if (cancelled) return
        const ids: string[] = res.data.byPatient?.[patient.id] ?? []
        const byId = new Map<string, any>(
          (res.data.doctors ?? []).map((doctor: any) => [doctor._id, doctor]),
        )
        setAllDoctors(ids.map(id => byId.get(id)).filter(Boolean))
      })
      .catch(err => {
        console.error(err)
        if (!cancelled) setAllDoctors([])
      })

    return () => {
      cancelled = true
    }
  }, [patient?.id])

  useEffect(() => {
    if (existingPlan) {
      setTestName(existingPlan.test)
      setTestType(typeTestDef.internal)

      setScheduleType(existingPlan.scheduleType)
      if (existingPlan.scheduleType === scheduleTypeDef.multi) {
        existingPlan.endPlanDate && setMultiDateEnd(existingPlan.endPlanDate)
        existingPlan.timesADay && setTimesaday(existingPlan.timesADay)
      } else if (existingPlan.scheduleType === scheduleTypeDef.every) {
        existingPlan.endPlanDate && setEveryDateEnd(existingPlan.endPlanDate)
        existingPlan.everyXHours && setEvery(existingPlan.everyXHours)
      } else if (existingPlan.scheduleType === scheduleTypeDef.continuous) {
        existingPlan.endPlanDate && setContinuousDateEnd(existingPlan.endPlanDate)
        existingPlan.severity && setSevirity(existingPlan.severity)
      }
    }
  }, [existingPlan])

  const onClose = () => {
    onCloseButtonClick()
  }

  const onSave = async () => {
    if (existingPlan && closeExistingPlan) {
      closePlan()
      onClose()
    } else if (testType === typeTestDef.internal) {
      createPlan()
      onClose()
    } else if (testType === typeTestDef.external) {
      setShowMedicalTestReferralModal(true)
    }
  }

  const onDiagnosisChanged = async (diagnoses: any) => {
    setNewExistsDiagnosis(diagnoses ? diagnoses : [])
  }

  const onBloodTypesChanged = async (bt: any) => {
    setBloodTypes(bt ? bt : [])
  }

  const createPlan = () => {
    if (!scheduleType) return
    const patientDiagnoses = [
      ...newExistsDiagnosis.map((pd: any) => {
        return { diagnosisCode: pd.diagnosisCode, diagnosisId: pd.diagnosisId }
      }),
    ]

    let examPlan: InternalExaminationPlan = {
      patientId: patient.id,
      patientDiagnoses,
      scheduleType: scheduleType,
      typeTest: testType,
      test: { ...testName },
      prescribedBy: prescribingDoctor,
      additionalRequests: doctorsRequests,
      orderSource: OrderSource.manual,
    }

    if (scheduleType === scheduleTypeDef.every) {
      examPlan.everyXHours = every
      examPlan.endPlanDate = everyDateEnd
    } else if (scheduleType === scheduleTypeDef.multi) {
      examPlan.timesADay = timesaday
      examPlan.endPlanDate = multiDateEnd
    } else if (scheduleType === scheduleTypeDef.once) {
      examPlan.withIn = withIn
    } else if (scheduleType === scheduleTypeDef.continuous) {
      examPlan.endPlanDate = continuousDateEnd
      examPlan.severity = severity
    }

    if (testName?.value === bloodChemistry.value) {
      examPlan.bloodTypes = bloodTypes
    }

    dispatch(createPatientSchedulePlan(examPlan))
    dispatch(fetchPatientExaminations(patient.id))
  }

  const closePlan = () => {
    const followUp: PatientsDiagnosisDiscussions = {
      patientId: patient.id,
      createdAt: new Date().toISOString(),
      createdBy: userSession.id,
      schedulePlanId: existingPlan?._id,
      id: '',
      rev: '',
      updatedAt: '',
      updatedBy: '',
      role: userSession.role,
      discussion: comments as string,
      patientDiagnoses: [...(existingPlan?.patientDiagnoses ? existingPlan?.patientDiagnoses : [])],
    }

    existingPlan?._id && dispatch(closePatientSchedulePlan(existingPlan?._id, followUp))
  }

  const onChangeRadioGroup = (e: any) => {
    setTestType(e.target.value)
  }

  function onChangeTimesaday(value: any) {
    setTimesaday(value)
  }

  function onChangeEvery(value: any) {
    setEvery(value)
  }

  function onChangeOnce(value: any) {
    setWithIn(value === '-1' || value === -1 ? 'ASAP' : Number(value))
  }

  const onChangeDoctor = (value: any) => {
    setPrescribingDoctor(value)
  }

  function disabledMultiEveryDate(current: any) {
    return (
      current &&
      (current < moment().startOf('day') || current > moment().add(5, 'days').endOf('day'))
    )
  }

  function disabledContinuousDate(current: any) {
    return (
      current &&
      (current < moment().startOf('day') || current > moment().add(6, 'months').endOf('day'))
    )
  }

  function disabledSaveButton() {
    let disabled = false
    if (testType === typeTestDef.external && !medicalTest) {
      disabled = true
    } else if (testType === typeTestDef.internal) {
      const testNameMissing = !testName
      const nurseDidntSelectDoctor = userSession.role === userRolesBase.nurse && !prescribingDoctor
      const scheduleTypeMissing = !scheduleType
      const multiDateEndMissing = scheduleType === scheduleTypeDef.multi && !multiDateEnd
      const everyDateEndMissing = scheduleType === scheduleTypeDef.every && !everyDateEnd
      const continuousDateEndMissing =
        scheduleType === scheduleTypeDef.continuous && !continuousDateEnd
      const closePlanCommentsMissing =
        closeExistingPlan && (!comments || !(comments.trim().length > 0))
      const bloodTypesMissing =
        testName?.value === bloodChemistry.value && (!bloodTypes || bloodTypes.length === 0)
      const diagnosisMissing = !newExistsDiagnosis || newExistsDiagnosis.length === 0

      if (
        testNameMissing ||
        nurseDidntSelectDoctor ||
        scheduleTypeMissing ||
        multiDateEndMissing ||
        everyDateEndMissing ||
        continuousDateEndMissing ||
        closePlanCommentsMissing ||
        bloodTypesMissing ||
        diagnosisMissing
      )
        disabled = true
    }

    return disabled
  }

  const getOption = (value: any) => {
    if (value === '-1') return t('examinations.asap')
    else if (value === '0') return t('examinations.withInHour')
    const hours = Number(value)
    if (hours > 24 && hours % 24 === 0) return `${hours / 24} d`
    return `${value} h`
  }

  const isExistingPlanDone = (existingPlan: InternalExaminationPlan) => {
    return moment(existingPlan.endPlanDate).endOf('day') < moment()
  }
  const onCloseAlertModal = () => {
    setShowAlertModal(false)
  }

  const body = (
    <>
      {/* External test option hidden for now - not needed right now */}
      {false && !existingPlan && (
        <Row>
          <Col span={20} className="py-1">
            <div className="py-1 typeTestDef">
              <Radio.Group
                buttonStyle="solid"
                size="large"
                onChange={onChangeRadioGroup}
                value={testType}
              >
                {/* <Radio.Button value={typeTestDef.internal}>
                  {t('examination.testType.internal')}
                </Radio.Button> */}
                <Radio.Button value={typeTestDef.external} className={externalEMR ? 'hidden' : ''}>
                  {t('examination.testType.external')}
                </Radio.Button>
              </Radio.Group>
            </div>
          </Col>
          <Col span={4}>
            <Button
              className="btnExternal"
              onClick={() => {
                if (externalEMR) {
                  window.open(ExternalEmr.getUrlPatient(patient.externalId))
                }
              }}
            >
              {t('examination.testType.external')}
            </Button>
          </Col>
        </Row>
      )}

      {testType == typeTestDef.external && (
        <Row>
          <Col span={24} className="py-2">
            <div
              className={
                classes.selectTestModal +
                ' ' +
                (testType == typeTestDef.external ? '' : 'displayNone')
              }
            >
              <Label
                htmlFor="patientTypeahead"
                isRequired={true}
                text={t('scheduling.appointment.selectMedicalTest')}
              />
              <MedicalTestSearch
                onSelect={(value: any) => {
                  setMedicalTest(value.value)
                }}
              ></MedicalTestSearch>
            </div>
          </Col>
        </Row>
      )}
      {testType == typeTestDef.internal && (
        <>
          <Row>
            <Col span={24} className="py-1">
              <div className={testType == typeTestDef.internal ? '' : 'displayNone'}>
                <div className={userSession.role === userRolesBase.nurse ? '' : 'displayNone'}>
                  <LockerWrapper>
                    <Form.Item
                      label={t('patient.testprescribedBy')}
                      style={{ color: '#495e83' }}
                      // name="prescribedBy"
                      // rules={[{ required: true, message: t('required.selectPrescribingDoctor') }]}
                    >
                      <Select
                        disabled={existingPlan !== undefined}
                        showSearch
                        options={allDoctors?.map(doctor => {
                          return {
                            label: `${doctor.firstName} ${doctor.lastName}`,
                            value: doctor._id,
                          }
                        })}
                        getPopupContainer={(triggerNode: any) => {
                          return triggerNode.parentNode
                        }}
                        placeholder={`-- ${t('patient.choose')} --`}
                        onChange={onChangeDoctor}
                        filterOption={(input, option) =>
                          ((option?.label as unknown) as string)
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                  </LockerWrapper>
                </div>
                <LockerWrapper>
                  <SelectWithLabelFormGroup
                    disabled={existingPlan !== undefined}
                    name=""
                    isRequired={true}
                    label={t('patient.testName')}
                    value={JSON.stringify(testName)}
                    isEditable={true}
                    options={tests
                      .filter(test => test.value !== deviceOrder.value && test.value != 'custom')
                      .map(test => {
                        // Out of service at this facility: kept in the list but not selectable, so
                        // the doctor can see the test exists and when it's expected back.
                        const outOfService = unavailableDevices[test.value]
                        const suffix = outOfService ? ` — ${unavailableLabel(outOfService, t)}` : ''

                        if (test.kind === 'device') {
                          return {
                            label: `${returnExamName(test.name, test.types[0])}${suffix}`,
                            value: JSON.stringify(test),
                            disabled: !!outOfService,
                          }
                        } else
                          return {
                            label: `${returnExamName(test.name)}${suffix}`,
                            value: JSON.stringify(test),
                            disabled: !!outOfService,
                          }
                      })}
                    onChange={(event: any) => {
                      setTestName(JSON.parse(event.target.value))
                    }}
                  />
                </LockerWrapper>
              </div>
            </Col>
          </Row>
          {!existingPlan && noticeMessage && (
            <Row>
              <Col span={24}>
                <Alert message={noticeMessage} type="warning" banner />
              </Col>
            </Row>
          )}
        </>
      )}
      {testName?.value === bloodChemistry.value && bloodChemistry.bloodTypes && (
        <Row>
          <Col span={24} className="py-1">
            <LockerWrapper>
              <ReactSelectWithLabelFormGroup
                isRequired={true}
                name="category"
                label={t('examinations.picoloBloodTypes')}
                isMulti
                value={bloodTypes?.map((bt: any) => {
                  return {
                    label: bt,
                    value: bt,
                  }
                })}
                isEditable
                options={bloodChemistry.bloodTypes.map(bt => {
                  return {
                    label: bt,
                    value: bt,
                  }
                })}
                onChange={(options: any) => {
                  const formatBloodTypes: any = options?.map((option: any) => option.value)
                  onBloodTypesChanged(formatBloodTypes)
                }}
              />
            </LockerWrapper>
          </Col>
        </Row>
      )}
      <Row>
        <Col span={24} className="py-1">
          <LockerWrapper>
            <ReactSelectWithLabelFormGroup
              isRequired={true}
              name="category"
              label={t('examinations.SelectDiagnosisFromPatientDiagnosis')}
              isMulti
              value={newExistsDiagnosis?.map((d: any) => {
                return {
                  label: diagnosis.find(diag => diag.diagnosisCode === d.diagnosisCode)
                    ?.diagnosisName as any,
                  value: d,
                }
              })}
              isEditable
              options={diagnosis
                ?.filter(
                  (d: PatientsDiagnosis) =>
                    !newExistsDiagnosis?.some(
                      (nd: PatientsDiagnosis) => nd.diagnosisCode === d.diagnosisCode,
                    ),
                )
                .map((d: PatientsDiagnosis) => {
                  return {
                    label: d.diagnosisName,
                    value: { diagnosisId: (d as any)?._id, diagnosisCode: d?.diagnosisCode },
                  }
                })}
              onChange={(options: any) => {
                const formatDiagnoses: any = options?.map((option: any) => option.value)
                onDiagnosisChanged(formatDiagnoses)
              }}
            />
          </LockerWrapper>
        </Col>
      </Row>
      {testType == typeTestDef.internal && (
        <>
          <LockerWrapper>
            <Form layout={'vertical'}>
              <Form.Item
                label={t('patient.additionalRequestsOptional')}
                style={{ color: '#495e83', width: '100%' }}
              >
                <TextArea
                  placeholder={t('examinations.addDescription')}
                  autoSize
                  onChange={e => setDoctorsRequests(e.target.value)}
                />
              </Form.Item>
            </Form>
          </LockerWrapper>
          <Row className="internal">
            <Col span={24}>
              <Label
                className={classes.label}
                text={t('patient.testFrequency')}
                // htmlFor={id}
                isRequired
              />
            </Col>
            <Col xs={24} md={8} className="py-1">
              <Checkbox
                disabled={existingPlan !== undefined}
                checked={scheduleType === scheduleTypeDef.once}
                onChange={(_event: any) => {
                  setScheduleType(scheduleTypeDef.once)
                }}
              >
                <div className="text">{t('examinations.once')}</div>
              </Checkbox>
              <Row className="py-1">
                <LockerWrapper>
                  <Select
                    className="mt-2 w-50"
                    defaultValue={'0'}
                    onChange={onChangeOnce}
                    getPopupContainer={(triggerNode: any) => {
                      return triggerNode.parentNode
                    }}
                    disabled={scheduleType !== scheduleTypeDef.once}
                  >
                    {[
                      0,
                      -1,
                      ...Array.from(Array(25).keys()).slice(1),
                      48,
                      72,
                      96,
                      120,
                      144,
                      168,
                    ].map((option: any) => (
                      <Option value={option.toString()} title={option}>
                        {getOption(option.toString())}
                      </Option>
                    ))}
                  </Select>
                </LockerWrapper>
              </Row>
            </Col>

            <Col xs={24} md={8} className="py-1 px-3 d-flex flex-column">
              <div className="text">{t('examinations.multipletimes')}</div>

              <Row className="py-1 mt-2 d-flex align-items-center">
                <Checkbox
                  disabled={existingPlan !== undefined}
                  className="checkbox"
                  checked={scheduleType === scheduleTypeDef.multi}
                  onChange={(_event: any) => {
                    setScheduleType(scheduleTypeDef.multi)
                  }}
                ></Checkbox>
                <div>
                  <LockerWrapper>
                    <InputNumber
                      disabled={scheduleType !== scheduleTypeDef.multi}
                      min={1}
                      max={3}
                      defaultValue={timesaday}
                      onChange={onChangeTimesaday}
                      value={timesaday}
                    />
                  </LockerWrapper>
                </div>
                <span className="text mx-2">{t('examinations.timesaday')}</span>
              </Row>
              <LockerWrapper>
                <DatePickerWithLabelFormGroup
                  className="mt-2 datepicker"
                  disabled={scheduleType !== scheduleTypeDef.multi}
                  value={multiDateEnd}
                  showYearDropdown={true}
                  name="examinationDate"
                  maxDate={new Date(Date.now().valueOf())}
                  onChange={(date: Date) => {
                    setMultiDateEnd(date?.toISOString())
                  }}
                  isEditable
                  disabledDate={disabledMultiEveryDate}
                  placeholder={t('testModal.selectEndDate')}
                />
              </LockerWrapper>

              <Row className="py-1 d-flex pt-3 align-items-center">
                <Checkbox
                  disabled={existingPlan !== undefined}
                  className="checkbox"
                  checked={scheduleType === scheduleTypeDef.every}
                  onChange={(_event: any) => {
                    setScheduleType(scheduleTypeDef.every)
                  }}
                ></Checkbox>
                <span className="text">Every</span>
                <LockerWrapper>
                  <InputNumber
                    className="mx-2"
                    disabled={scheduleType !== scheduleTypeDef.every}
                    min={1}
                    max={23}
                    defaultValue={every}
                    onChange={onChangeEvery}
                    value={every}
                  />
                </LockerWrapper>
                <span className="text">hours</span>
              </Row>
              <LockerWrapper>
                <DatePickerWithLabelFormGroup
                  className="mt-2 datepicker"
                  disabled={scheduleType !== scheduleTypeDef.every}
                  value={everyDateEnd}
                  showYearDropdown={true}
                  name="examinationDate"
                  maxDate={new Date(Date.now().valueOf())}
                  onChange={(date: Date) => {
                    setEveryDateEnd(date?.toISOString())
                  }}
                  isEditable
                  disabledDate={disabledMultiEveryDate}
                  placeholder={t('testModal.selectEndDate')}
                />
              </LockerWrapper>
            </Col>
            {testName?.value === edanVitals.value && (
              <Col xs={24} md={8} className="py-1 px-4">
                <Checkbox
                  disabled={existingPlan !== undefined}
                  checked={scheduleType === scheduleTypeDef.continuous}
                  onChange={(_event: any) => {
                    setScheduleType(scheduleTypeDef.continuous)
                  }}
                >
                  <span className="text">{t('examinations.continuous')}</span>
                </Checkbox>
                <Row className="py-1">
                  <LockerWrapper>
                    <Select
                      className="mt-2"
                      getPopupContainer={(triggerNode: any) => {
                        return triggerNode.parentNode
                      }}
                      disabled={scheduleType !== scheduleTypeDef.continuous}
                      value={severity}
                      options={severities}
                      onChange={(value: any) => {
                        setSevirity(value)
                      }}
                    />
                  </LockerWrapper>
                </Row>

                <div>
                  <LockerWrapper>
                    <DatePickerWithLabelFormGroup
                      className="mt-2"
                      disabled={scheduleType !== scheduleTypeDef.continuous}
                      value={continuousDateEnd}
                      showYearDropdown={true}
                      name="examinationDate"
                      maxDate={new Date(Date.now().valueOf())}
                      onChange={(date: Date) => {
                        setContinuousDateEnd(date?.toISOString())
                      }}
                      isEditable
                      disabledDate={disabledContinuousDate}
                      placeholder={t('testModal.selectEndDate')}
                    />
                  </LockerWrapper>
                </div>
              </Col>
            )}
          </Row>
          {existingPlan && isExistingPlanDone(existingPlan) && (
            <>
              <Row>
                <LockerWrapper>
                  <Checkbox
                    className="checkbox"
                    checked={closeExistingPlan}
                    onChange={event => {
                      setCloseExistingPlan(event.target.checked)
                    }}
                  >
                    {t('schedule.closePlan')}
                  </Checkbox>
                </LockerWrapper>
              </Row>
              <Row>
                <Col span={24} className="py-1">
                  <LockerWrapper>
                    <TextAreaWithLabelFormGroup
                      disabled={!closeExistingPlan}
                      name="text"
                      label={t('examinations.comments')}
                      value={comments}
                      isEditable={true}
                      placeholder={t('examinations.addDescription')}
                      onChange={(event: any) => {
                        setComments(event.target.value)
                      }}
                    />
                  </LockerWrapper>
                </Col>
              </Row>
            </>
          )}
        </>
      )}
    </>
  )

  return (
    <>
      <NewModal
        show={show}
        title={t('patient.appointments.addTestExamination')}
        body={body}
        maxWidth="md"
        closeButton={{
          children: t('actions.cancel'),
          color: 'danger',
          onClick: onClose,
        }}
        successButton={{
          disabled: parent === 'view' || disabledSaveButton(),
          style: { borderWidth: 0 },
          children: t('actions.save'),
          color: 'success',
          icon: 'add',
          iconLocation: 'left',
          onClick: () => {
            patient.status === patientStatus.inactive ? setShowAlertModal(true) : onSave()
          },
        }}
        middleButton={{
          style: { borderColor: '#D8DEE9', background: 'white', color: '#495E83', borderWidth: 1 },
          children: t('actions.cancel'),
          onClick: onClose,
        }}
        className="testModal"
      />
      <NewModal
        show={showAlertModal}
        title={t('showAlertModal.title.patientInActive')}
        body={t('showAlertModal.messageBody.patientInActive')}
        closeButton={{
          children: t('actions.cancel'),
          color: 'danger',
          onClick: onCloseAlertModal,
        }}
        middleButton={{
          style: { borderColor: '#D8DEE9', background: 'white', color: '#495E83', borderWidth: 1 },
          children: t('actions.cancel'),
          onClick: onCloseAlertModal,
        }}
        successButton={{
          style: { borderWidth: 0 },
          children: t('showAlertModal.save.patientInActive'),
          color: 'success',
          iconLocation: 'left',
          onClick: onSave,
        }}
      ></NewModal>
      {showMedicalTestReferralModal && (
        <VdgMedicalTestReferralModal
          show={true}
          parent={parent}
          patient={patient}
          onCloseButtonClick={() => {
            setShowMedicalTestReferralModal(false)
            onClose()
          }}
          medicalTest={medicalTest}
          topic={topic}
        />
      )}
    </>
  )
}

export default ComponentWrapperWithAITracking(VdgTestModal, 'VdgTestModal')
